/**
 * Layout: Content - Afbeelding
 * Slug: content_afbeelding
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.content_afbeelding-layout');

	layouts.forEach((layout) => {
		
	});
});
